// @catalog F.006
// VendorsTable — wrapper de StoreAnalysisTable para vendedores SO (Bloque 8
// plan dashboard_ux_ventas_margenes 2026-05-21). Reusa la misma tabla que
// StoresPOSTable; conceptualmente es un canal distinto (Sale Orders vs POS).
import type { StoreMetrics } from "../../services/analytics.service";
import { StoreAnalysisTable } from "./StoresPOSTable";

interface VendorsTableProps {
  vendors: StoreMetrics[];
}

export function VendorsTable({ vendors }: VendorsTableProps): JSX.Element {
  return <StoreAnalysisTable stores={vendors} />;
}
